import { callFirebaseFunction } from 'boot/firebase';

/**
 * @param {string} clinicId
 * @return {Promise<boolean>}
 */
// eslint-disable-next-line import/prefer-default-export
export async function hasClinicEverAudited(clinicId) {
  if (!clinicId) {
    return false;
  }

  const { data } = await callFirebaseFunction('hasNoteAuditorBeenUsed', { clinicId });

  return !!data?.hasBeenUsed;
} // hasClinicEverAudited()
